export const orderStage = {
  WAITING_FOR_CONFIRMATION: 'WAITING_FOR_CONFIRMATION',
  REFUNDING: 'REFUNDING',
  WAITING_FOR_PAYMENT: 'WAITING_FOR_PAYMENT',
  WAITING_FOR_CHECK_IN: 'WAITING_FOR_CHECK_IN',
  CHECKED_IN: 'CHECKED_IN',
  LOST: 'LOST',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  AFTER_SALES_INTERVENTION: 'AFTER_SALES_INTERVENTION',
  IN_PROGRESS: 'IN_PROGRESS',
};

export const orderSecondaryStage = {
  NON_CONFIRM_IN_TIME: 'NON_CONFIRM_IN_TIME',
  REJECT_BY_LANDLORD: 'REJECT_BY_LANDLORD',
  CANCELLED_BY_SERVICE_TEAM: 'CANCELLED_BY_SERVICE_TEAM',
  CANCEL_BY_LANDLORD: 'CANCEL_BY_LANDLORD',
  ALL_NON_REFUND: 'ALL_NON_REFUND',
  PARTIAL_NON_REFUND: 'PARTIAL_NON_REFUND',
  PENDING_COUNTER_OFFER: 'PENDING_COUNTER_OFFER',
  COUNTER_OFFER_NON_CONFIRM_IN_TIME: 'COUNTER_OFFER_NON_CONFIRM_IN_TIME',
  NO_INVENTORY_AVAILABLE: 'NO_INVENTORY_AVAILABLE',
  NON_SIGN_IN_TIME: 'NON_SIGN_IN_TIME',
  PENDING_GUARANTOR_INFO: 'PENDING_GUARANTOR_INFO',
  NO_NEED_GUARANTOR: 'NO_NEED_GUARANTOR',
  GUARANTOR_PROVIDED: 'GUARANTOR_PROVIDED',
  NON_PAY_IN_TIME: 'NON_PAY_IN_TIME',
  CANCEL_BY_STUDENT: 'CANCEL_BY_STUDENT',
  COUNTER_OFFER_REJECTED_BY_STUDENT: 'COUNTER_OFFER_REJECTED_BY_STUDENT',
  COUNTER_OFFER_ACCEPTED_BY_STUDENT: 'COUNTER_OFFER_ACCEPTED_BY_STUDENT',
};

export const instantBookOrderStage = {
  BOOKING_CONFIRMED: 'BOOKING_CONFIRMED',
  COMPLETED: 'COMPLETED',
  CHECKED_IN: 'CHECKED_IN',
  CANCELLED: 'CANCELLED',
  LOST: 'LOST',
  FILLING_PERSONAL_INFO: 'FILLING_PERSONAL_INFO',
  SIGNING_AGREEMENT: 'SIGNING_AGREEMENT',
  MAKING_PAYMENT: 'MAKING_PAYMENT',
  REFUNDING: 'REFUNDING',
  SELECTING_PAYMENT_PLAN: 'SELECTING_PAYMENT_PLAN',
};

export const instantBookOrderSecondaryStage = {
  NON_SIGN_IN_TIME: 'NON_SIGN_IN_TIME',
  NON_CONFIRM_IN_TIME: 'NON_CONFIRM_IN_TIME',
  NO_INVENTORY_AVAILABLE: 'NO_INVENTORY_AVAILABLE',
  PENDING_GUARANTOR_INFO: 'PENDING_GUARANTOR_INFO',
  REJECT_BY_LANDLORD: 'REJECT_BY_LANDLORD',
  CANCELLED_BY_SERVICE_TEAM: 'CANCELLED_BY_SERVICE_TEAM',
  CANCEL_BY_LANDLORD: 'CANCEL_BY_LANDLORD',
  ALL_NON_REFUND: 'ALL_NON_REFUND',
  PARTIAL_NON_REFUND: 'PARTIAL_NON_REFUND',
  NO_NEED_GUARANTOR: 'NO_NEED_GUARANTOR',
  GUARANTOR_PROVIDED: 'GUARANTOR_PROVIDED',
  NON_PAY_IN_TIME: 'NON_PAY_IN_TIME',
  CANCEL_BY_STUDENT: 'CANCEL_BY_STUDENT',
};

export const counterOfferStage = {
  WAITING_FOR_CONFIRMATION: 'WAITING_FOR_CONFIRMATION',
  CANCELLED: 'CANCELLED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  LOST: 'LOST',
};

export const fullAutomaticStageText = {
  IN_PROGRESS: 'In progress',
  FILLING_PERSONAL_INFO: 'Filling personal info',
  SIGNING_AGREEMENT: 'Signing agreement',
  MAKING_PAYMENT: 'Making payment',
  BOOKING_CONFIRMED: 'Booking confirmed',
  CANCELLED: 'Cancelled',
  LOST: 'Lost',
};

export const leadGenerationStageText = {
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  IN_PROGRESS: 'In progress',
  LOST: 'Lost',
};

export const herculesBookingStatus = {
  WAITING_FOR_CONFIRMATION: 'waiting_for_confirmation',
  WAITING_FOR_PAYMENT: 'waiting_for_payment',
  REFUNDING: 'refunding',
  LOST: 'lost',
  CANCELLED: 'cancelled',
  WAITING_FOR_CHECK_IN: 'waiting_for_check_in',
  CHECKED_IN: 'checked_in',
  COMPLETED: 'completed',
};

export const manualBookingStatus = {
  LOST: 'lost',
  CANCELLATION: 'cancellation',
  COMPLETED: 'completed',
};

export const orderRefundStatus = {
  NEW: 'NEW',
  PENDING_REFUND: 'PENDING_REFUND',
  REFUND_CONFIRMATION: 'REFUND_CONFIRMATION',
  REFUNDED: 'REFUNDED',
  VOID: 'VOID',
};

export const orderRefundProcessStatus = {
  NEW: 'NEW',
  PENDING_REFUND: 'PENDING_REFUND',
  REFUND_CONFIRMATION: 'REFUND_CONFIRMATION',
  REFUNDED: 'REFUNDED',
};

export const landlordBookingStatus = [
  { text: 'Ready for Approval', value: 'READY_FOR_APPROVAL' },
  { text: 'Pending Approval', value: 'PENDING_APPROVAL' },
  { text: 'Approved', value: 'APPROVED' },
  { text: 'Ready to Invoice', value: 'READY_TO_INVOICE' },
  { text: 'Partial Invoiced', value: 'PARTIAL_INVOICED' },
  { text: 'Invoiced', value: 'INVOICED' },
  { text: 'Paid', value: 'PAID' },
  { text: 'Cancelled', value: 'CANCELLED' },
  { text: 'No Show', value: 'NO_SHOW' },
  { text: 'Unclaimable', value: 'UNCLAIMABLE' },
];

export const allBookingStatus = {
  NEW: 'NEW',
  LOST: 'LOST',
  IN_CONSULTATION: 'IN_CONSULTATION',
  APPLICATION_PROCESSING: 'APPLICATION_PROCESSING',
  COMPLETED: 'COMPLETED',
  PAY_THROUGH_SCOM: 'PAY_THROUGH_SCOM',
  LEAD_GEN: 'LEAD_GEN',
  CANCELLATION: 'CANCELLATION',
};

export const bookingJourneyType = {
  LEAD_GENERATION: 'LEAD_GENERATION',
  SEMI_AUTOMATIC: 'SEMI_AUTOMATIC',
  FULL_AUTOMATIC: 'FULL_AUTOMATIC',
  INSTANT_BOOK: 'INSTANT_BOOK',
  MANUAL: 'MANUAL',
};

export const INSTANT_BOOKING_STEP = {
  FILLING_PERSONAL_INFO: 'FILLING_PERSONAL_INFO',
  SIGNING_AGREEMENT: 'SIGNING_AGREEMENT',
  MAKING_PAYMENT: 'MAKING_PAYMENT',
};

export const INSTANT_BOOKING_STATUS = {
  BOOKING_CONFIRMED: 'BOOKING_CONFIRMED',
  COMPLETED: 'COMPLETED',
  CHECKED_IN: 'CHECKED_IN',
  CANCELLED: 'CANCELLED',
  LOST: 'LOST',
};

export const STAGE_COLORS = {
  ORANGE: '#F9A600',
  BLUE: '#6B92F3',
  GREEN: '#3BC56F',
  RED: '#FF4D4F',
  GRAY: '#BFBFBF',
};

export const BOOKING_STAGE_COLORS_MAP = {
  PENDING_APPROVAL: STAGE_COLORS.ORANGE,
  NEEDS_UPDATE: STAGE_COLORS.ORANGE,

  WAITING_FOR_CONFIRMATION: STAGE_COLORS.BLUE,
  WAITING_FOR_PAYMENT: STAGE_COLORS.BLUE,
  WAITING_FOR_CHECK_IN: STAGE_COLORS.BLUE,
  CHECKED_IN: STAGE_COLORS.BLUE,
  IN_PROGRESS: STAGE_COLORS.BLUE,
  FILLING_PERSONAL_INFO: STAGE_COLORS.BLUE,
  SIGNING_AGREEMENT: STAGE_COLORS.BLUE,
  MAKING_PAYMENT: STAGE_COLORS.BLUE,
  PAID: STAGE_COLORS.BLUE,
  INVOICED: STAGE_COLORS.BLUE,
  NEW: STAGE_COLORS.BLUE,
  READY_FOR_APPROVAL: STAGE_COLORS.BLUE,
  READY_TO_INVOICE: STAGE_COLORS.BLUE,

  BOOKING_CONFIRMED: STAGE_COLORS.GREEN,
  COMPLETED: STAGE_COLORS.GREEN,

  REFUNDING: STAGE_COLORS.RED,
  VOID: STAGE_COLORS.RED,

  CANCELLED: STAGE_COLORS.GRAY,
  LOST: STAGE_COLORS.GRAY,
};

export const ALL_BOOKING_STAGES = {
  WAITING_FOR_CONFIRMATION: 'waiting_for_confirmation',
  WAITING_FOR_PAYMENT: 'waiting_for_payment',
  WAITING_FOR_CHECK_IN: 'waiting_for_check_in',
  CHECKED_IN: 'checked_in',
  AFTER_SALES_INTERVENTION: 'after_sales_intervention',
  FILLING_PERSONAL_INFO: 'filling_personal_info',
  SIGNING_AGREEMENT: 'signing_agreement',
  MAKING_PAYMENT: 'making_payment',
  BOOKING_CONFIRMED: 'booking_confirmed',
  SELECTING_PAYMENT_PLAN: 'selecting_payment_plan',
  IN_PROGRESS: 'in_progress',
  REFUNDING: 'refunding',
  LOST: 'lost',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
};

export const ONGOING_STAGES = [
  'WAITING_FOR_PAYMENT',
  'IN_PROGRESS',
  'AFTER_SALES_INTERVENTION',
  'FILLING_PERSONAL_INFO',
  'SIGNING_AGREEMENT',
  'MAKING_PAYMENT',
  'WAITING_FOR_CONFIRMATION',
  'SELECTING_PAYMENT_PLAN',
  'REFUNDING',
];

export const triggerPointsTypes = {
  COMPLETED: 'COMPLETED',
  CREATED: 'CREATED',
};
